module.exports = __webpack_public_path__ + "img/2.912d6a26.png";